<div class="container min-h-full flex flex-col mx-auto px-4 md:px-6 pt-8 pb-4">
  <div class="flex items-center mb-4 min-h-10">
    <h2 class="text-2xl font-medium">Facturatie</h2>
  </div>

  <div class="flex gap-3 rounded-lg border border-blue-200 bg-blue-50 p-4 mb-8">
    <mat-icon class="shrink-0 text-blue-600 mt-0.5">info</mat-icon>
    <div class="text-sm text-gray-800 space-y-2">
      <p class="font-medium text-gray-900">Hoe werkt facturatie?</p>
      <p>
        Wanneer een unit een <strong>inkoopnummer</strong> en <strong>factuur e-mailadres</strong>
        heeft ingevuld, ontvangt deze unit een eigen factuur op het opgegeven e-mailadres.
      </p>
      <p>
        Heeft een unit deze gegevens <strong>niet</strong> ingevuld, dan zoekt het systeem automatisch
        naar boven in de hiërarchie tot er een bovenliggende unit wordt gevonden die wél
        facturatiegegevens heeft. De kosten van alle onderliggende units zonder eigen gegevens worden
        dan samengevoegd op de factuur van die bovenliggende unit.
      </p>
      <p>
        Twee units met dezelfde gegevens ontvangen <strong>elk een aparte factuur</strong>
        — elke unit met ingevulde gegevens wordt altijd apart gefactureerd.
      </p>
    </div>
  </div>

  <form class="flex flex-col gap-12" [formGroup]="form">
    <div class="grid lg:grid-cols-3 gap-4">
      <div>
        <div class="font-medium">Facturatiegegevens</div>
        <div class="text-sm text-pretty text-gray-700 mt-1">
          Gegevens die worden gebruikt voor de facturatie van deze unit.
        </div>
      </div>
      <div class="col-span-2 bg-white rounded-lg">
        <div class="p-8">
          <div class="grid grid-cols-6 gap-4 max-w-2xl" formGroupName="invoice">
            <div class="col-span-full lg:col-span-4">
              <div class="space-y-2">
                <label for="purchaseNumber" class="block font-medium text-sm select-none"
                  >Inkoopnummer</label
                >

                <mat-form-field class="w-full">
                  <input
                    matInput
                    formControlName="purchaseNumber"
                    autocomplete="off"
                    enterkeyhint="next"
                    id="purchaseNumber"
                    type="text"
                  />

                  @if (invoiceControls.purchaseNumber.hasError('requiredForRoot')) {
                    <mat-error>Verplicht voor de hoofd-unit</mat-error>
                  } @else if (invoiceControls.purchaseNumber.hasError('requiredByPeer')) {
                    <mat-error>Verplicht wanneer factuur e-mailadres is ingevuld</mat-error>
                  } @else if (invoiceControls.purchaseNumber.hasError('maxlength')) {
                    <mat-error
                      >Max.
                      {{ invoiceControls.purchaseNumber.getError('maxlength').requiredLength }}
                      karakters</mat-error
                    >
                  }
                </mat-form-field>
              </div>
            </div>

            <div class="col-span-full lg:col-span-4">
              <div class="space-y-2">
                <label for="invoiceEmail" class="block font-medium text-sm select-none"
                  >Factuur e-mailadres</label
                >

                <mat-form-field class="w-full">
                  <input
                    matInput
                    formControlName="invoiceEmail"
                    autocomplete="email"
                    enterkeyhint="done"
                    id="invoiceEmail"
                    type="email"
                  />

                  @if (invoiceControls.invoiceEmail.hasError('requiredForRoot')) {
                    <mat-error>Verplicht voor de hoofd-unit</mat-error>
                  } @else if (invoiceControls.invoiceEmail.hasError('requiredByPeer')) {
                    <mat-error>Verplicht wanneer inkoopnummer is ingevuld</mat-error>
                  } @else if (invoiceControls.invoiceEmail.hasError('email')) {
                    <mat-error>Geen geldig e-mailadres</mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *appHasPermission="'unit:update'" class="flex justify-end">
      <button
        mat-flat-button
        type="submit"
        [disabled]="form.invalid || submitted()"
        (click)="handleSubmit()"
      >
        Opslaan
      </button>
    </div>
  </form>
</div>
